import type { ReactNode } from "react";

export function KpiCard({
  label,
  value,
  tone,
  delta,
  deltaTone,
  icon,
}: {
  label: string;
  value: ReactNode;
  tone?: "primary" | "warn" | "danger";
  delta?: string;
  deltaTone?: "up" | "warn";
  icon?: ReactNode;
}) {
  return (
    <div className={`kpi${tone ? " " + tone : ""}`}>
      <div className="kpi-head">
        <div className="label">{label}</div>
        {icon && <span className="kpi-ico">{icon}</span>}
      </div>
      <div className="value">{value}</div>
      {delta && <div className={`delta${deltaTone ? " " + deltaTone : ""}`}>{delta}</div>}
    </div>
  );
}

export function KpiSkeleton() {
  return (
    <div className="kpi">
      <div className="skel" style={{ height: 12, width: 90 }} />
      <div className="skel" style={{ height: 28, width: 70, marginTop: 12 }} />
    </div>
  );
}
